@if (type === 'pie' || type === 'polarArea') {
  <div class="px-2 py-2 align-items-start">
    <div
      [ngClass]="{
        'flex-column': legendPosition === 'right' || legendPosition === 'left',
      }"
      class="p-card p-2 mb-1 flex gap-2">
      @for (dataset of datasets; track $index) {
        <div
          class="flex gap-2 align-items-center text-color text-left"
          [ngClass]="{
            'line-through text-color-secondary': isHidden(
              $index,
              dataset,
              true
            ),
          }"
          (click)="toggleDataset(dataset)">
          @if (datasets.length > 1) {
            <p-badge
              [severity]="
                isHidden($index, dataset, true) ? 'secondary' : 'info'
              "
              styleClass="text-xs"
              [value]="$index + 1" />
          }
          <span>
            @if (dataset.group) {
              <strong>{{ dataset.group }}:</strong>
            }
            {{ dataset.label }}</span
          >
        </div>
      }
    </div>
  </div>
}

<div
  class="px-2 py-2 align-items-start flex gap-1 flex-wrap"
  [ngClass]="{
    'flex-column align-items-start':
      legendPosition === 'right' || legendPosition === 'left',
    'align-items-end': legendPosition === 'top' || legendPosition === 'bottom',
  }">
  @if (isAxisLegend) {
    <ng-container *ngFor="let group of axisLegendItems">
      <div
        [ngClass]="{
          'flex-column w-full':
            legendPosition === 'right' || legendPosition === 'left',
        }"
        class="p-card p-2 mb-1 text-xs text-left flex gap-1">
        <div
          class="flex gap-1"
          [ngClass]="{
            'flex-column w-full':
              !!group.key ||
              legendPosition === 'left' ||
              legendPosition === 'right',
          }">
          @if (group.key) {
            <strong>{{ group.key }}</strong>
          }
          <div
            class="legend-items flex"
            [ngClass]="{
              'flex-column gap-1':
                legendPosition === 'left' || legendPosition === 'right',
              'gap-2': legendPosition === 'top' || legendPosition === 'bottom',
            }">
            <div
              class="legend-item flex align-items-baseline gap-1 cursor-pointer"
              [ngClass]="{
                'line-through text-color-secondary': isDatasetHidden(dataset),
              }"
              *ngFor="let dataset of group.datasets"
              (click)="toggleDataset(dataset)">
              @if (dataset.backgroundColor) {
                <span
                  class="legend-color"
                  [style.backgroundColor]="
                    getDatasetColor(dataset.backgroundColor)
                  ">
                </span>
              }
              <span>{{ dataset.label }}</span>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  } @else {
    @for (group of groupedLabels | keyvalue; track group.key) {
      @if (group.value && group.value.length > 0) {
        <div
          [ngClass]="{
            'flex-column w-full gap-2':
              legendPosition === 'right' || legendPosition === 'left',
          }"
          class="p-card p-2 mb-1 text-xs text-left flex gap-2">
          @if (group.key !== 'ungrouped') {
            <strong>{{ group.key }}</strong>
          }
          <div
            class="legend-item flex align-items-baseline gap-1 cursor-pointer"
            *ngFor="let item of group.value"
            (click)="toggleDataPoint(item.index, item)"
            [ngClass]="{
              'line-through text-color-secondary': isHidden(item.index),
            }">
            <span class="legend-color" [style.backgroundColor]="item.color">
            </span>
            <span>
              {{ item.label }}
            </span>
          </div>
        </div>
      }
    }
  }
</div>
